$(document).on("click", "#Subscribe", function (e) {
  e.preventDefault();
  var form = $(this).closest("form"),
    email = $(form).find('[type="email"]').val();

  console.log(email);

  $.ajax({
    type: "POST",
    async: true,
    crossDomain: true,
    url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
    data: {
      g: "TcMrGD",
      email: email,
      $source: "Join the newsletter",
    },
    dataType: "JSON",
    success: function (data) {
      console.log(JSON.stringify(data));
      if( data.success ){
        $(form).find('[type="email"]').val('');
        $(document).find('.success-message-form').show();
        setTimeout(function(){
          $(document).find('.success-message-form').hide();
        },5000)
      }
    },
  });
});
